module.exports = __webpack_public_path__ + "img/coming-soon.bbde3217.svg";